import React from 'react';

// Simplified version - no real-time connection monitoring
export default function ConnectionStatusIndicator() {
  // Component disabled - real-time features removed for performance
  return null;
}